module.exports = __webpack_public_path__ + "img/list.6dd20e7f.svg";